export default () => Component(function ($context) {
	return $context.select('.card');
}, function ($card, self) {
	$.extend(self, {
		bindEvents: function() {
			$card.find('.card__view-btn').on('click', function(e) {
				e.preventDefault();
				const url = $card.data('url');
				ModalUtil.openAjax(url + '?cart=1');
				if( typeof yaCounter26476791 != 'undefined' ) {
					yaCounter26476791.reachGoal('fastview');
				}
			});

			$card.on('click', '.card__btn-buy', function() {
				$card.find('.buy1click-open-button').trigger('click');
			});

			$card.find('.card__btn-analog').on('click', function(e) {
				e.preventDefault();
				Cookies.set('to_upselling', 'true');
				if( typeof yaCounter26476791 != 'undefined' ) {
					yaCounter26476791.reachGoal('ANALOG_LIST');
				}

				window.location.href = $card.data('url');
			});
			$(window).on('resize', self.changeB1cButton);
		},
		hideGroupsLinks: function () {
			var $groupLinksBlocks = $card.find('.card__productgroups-block_d');

			if ($groupLinksBlocks.length === 0) {
				return;
			}

			$groupLinksBlocks.each(function () {
				const $groupBlock = $(this);
				const groupBlockWidth = $groupBlock.outerWidth() - 25;
				const $groupLinks = $groupBlock.find('.card__group-link');
				let commonWidth = 0;
				let hiddenCount = 0;

				$groupLinks.each(function () {
					var $link = $(this);
					var linkWidth = $link.outerWidth() + parseFloat($link.css('margin-right'));
					commonWidth += linkWidth;

					if (commonWidth > groupBlockWidth) {
						requestAnimationFrame(() => {
							$link.addClass('card__group-link--hidden');
						});
						hiddenCount += 1;
					}
				});

				if (hiddenCount > 0) {
					requestAnimationFrame(() => {
						const $countBlock = $(`<a class="productgroups__link card__group-link card__group-link--count btn btn--option" href="${$card.data('url')}">+${hiddenCount}</a>`)
						$groupBlock.find('.card__group-links').addClass('card__group-links--hidden').append($countBlock);
					});
				}
			})
		},
		initSwiper: function() {
			var $imagesGallery = $card.find('.card__gallery--m');

			if ($imagesGallery.length === 0) {
				return;
			}

			var isDinamicBullets = false;

			if (ResponsiveUtil.isToTablet()) {
				isDinamicBullets = true;
			}

			new Swiper($imagesGallery.get(0), {
				preloadImages: false,
				slidesPerView: 1,
				spaceBetween: 0,
				pagination: {
					el: '.card-gallery-pagination',
					bulletClass: 'card-gallery-pagination__bullet',
					bulletActiveClass: 'card-gallery-pagination__bullet_active',
					dynamicBullets: isDinamicBullets,
					dynamicMainBullets: 5,
					clickable: true,
				}
			});
		},
		initDesktopSlider: function() {
			var $galleryContainer = $card.find('.card__gallery-container');
			var $imagesGallery = $galleryContainer.find('.card__gallery--d');

			if ($imagesGallery.length === 0) {
				return;
			}

			var $imagesGalleryImages = $imagesGallery.find('.image');
			var pagination = $imagesGallery.next('.card__gallery-pagination');
			var paginationItems = pagination.find('.card-gallery-pagination__bullet');
			var fieldsPagination = $imagesGallery.find('.card__gallery-field-pagination');
			var fieldsPaginationItems = fieldsPagination.find('.card__gallery-field-item');
			paginationItems.on('click', function (e) {
				e.preventDefault();
				var bullet = $(this);
				var index = bullet.data('index');

				$imagesGalleryImages.hide();
				$($imagesGalleryImages[index]).show();
				paginationItems.removeClass('card-gallery-pagination__bullet_active');
				bullet.addClass('card-gallery-pagination__bullet_active');
			});
			fieldsPaginationItems.on('mouseover', function () {
				var field = $(this);
				var index = field.data('index');

				pagination.find('[data-index="' + index + '"]').trigger('click');
			});
			$galleryContainer.on('mouseleave', function (e) {
				pagination.find('[data-index="0"]').trigger('click');
			});
		},
		initSlider: function() {
			this.initSwiper();
			this.initDesktopSlider();
		}
	});

	self.bindEvents();
	self.initSlider();
	self.hideGroupsLinks();
});
